import {
  FDListItem, FDListItemIcon, FDListItemText,
} from '@facet-wealth/design';
import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { dataAttrs } from 'Helpers/Testing';

const NeverIncludeItem = () => {
  const {
    resource,
  } = useMetaLayoutContext();
  return (
    <FDListItem
      key={resource.id()}
      {...dataAttrs('planner-guide-never-include-list-item')}
    >
      <FDListItemIcon
        icon={'close'}
        color={'error'}
      />
      <FDListItemText
        primaryText={resource.attr('description')}
        secondaryText={resource.attr('examples')}
      />
    </FDListItem>
  );
};

export default NeverIncludeItem;
